// src/utils/flatten.js

/**
 * Flattens a JSON object/array into a list of "path:value" strings.
 * Matches the app's existing output format.
 *
 * Example output item:
 *   $document.company.employees[0].name:John
 *
 * @param {any} inputJson - Parsed JSON object/array
 * @param {string} rootPath - Root name to start from (default "$document")
 * @returns {string[]} array of "path:value" lines
 */
export function flattenJson(inputJson, rootPath = "$document") {
  const out = [];
  doJsonFlatter(inputJson, rootPath, out);
  return out;
}

function doJsonFlatter(inputJson, rootpath, out) {
  if (Array.isArray(inputJson)) {
    for (let index = 0; index < inputJson.length; index++) {
      const value = inputJson[index];

      if (
        value === null ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      ) {
        out.push(`${rootpath}[${index}]:${value}`);
      } else if (Array.isArray(value)) {
        doJsonFlatter(value, `${rootpath}[${index}]`, out);
      } else if (typeof value === "object") {
        doFlatterTheObject(value, `${rootpath}[${index}]`, out);
      }
    }
  } else if (inputJson !== null && typeof inputJson === "object") {
    doFlatterTheObject(inputJson, rootpath, out);
  }
}

function doFlatterTheObject(input, path, out) {
  for (let key in input) {
    const value = input[key];

    if (value === null) {
      out.push(`${path}.${key}:null`);
    } else if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      out.push(`${path}.${key}:${value}`);
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        out.push(`${path}.${key}:[]`);
      } else {
        for (let innerKey in value) {
          const innerVal = value[innerKey];
          const innerPath = `${path}.${key}`;
          if (
            innerVal === null ||
            typeof innerVal === "string" ||
            typeof innerVal === "number" ||
            typeof innerVal === "boolean"
          ) {
            out.push(`${innerPath}[${innerKey}]:${innerVal}`);
          } else if (Array.isArray(innerVal)) {
            doJsonFlatter(innerVal, `${innerPath}[${innerKey}]`, out);
          } else if (typeof innerVal === "object") {
            doFlatterTheObject(innerVal, `${innerPath}[${innerKey}]`, out);
          }
        }
      }
    } else if (typeof value === "object") {
      if (isEmpty(value)) {
        out.push(`${path}.${key}:{}`);
      }
      doFlatterTheObject(value, `${path}.${key}`, out);
    }
  }
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
